import * as types from '../constants/ActionTypes';
export const initialState = {};
export default (state = initialState, action) => {
    switch (action.type) {
        case types.ADD_REPOSITORY: {
            return {
                ...action.payload,
            };
        }
        case types.UPDATE_REPOSITORY:
            return {
                ...state,
                ...action.payload,
            };
        case types.CLEAR_REPOSITORY:
            return {};
        default:
            return state;
    }
};
